import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import * as actions from '../../_redux/invoiceOrdersActions';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Validation} from '../../../../../utils';

const PopupSendToCreation = ({dirty, values, handleSubmit, tableRows}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [valid, setValid] = useState(false);
  const invoiceOrdersList = useSelector(
    (state) => state.invoiceOrdersEditAndSend.entities,
    shallowEqual
  );

  const getInvoices = (object) => {
    const array = [];
    for (let key in object) {
      if (values[key] && key !== 'types')
        array.push(key);
    }
    return array;
  };
  const invoiceOrdersArray = getInvoices(values);

  const chosenArray = tableRows && Array.isArray(tableRows)
    ? tableRows.map(item => invoiceOrdersArray.includes(item._id) ? item : null).filter(Boolean)
    : [];
  const amounts = chosenArray.map(item => item.amount).join(', ');
  const createdDates = chosenArray
    .map(item => item.createdAt ? moment(item.createdAt).format('DD-MM-YYYY') : '')
    .join(', ');
  const agentIDs = chosenArray.map(item => item.agentID).join(', ');

  const sendInvoiceFunc = (invoiceOrdersArray) => () => {
    dispatch(actions.sendInvoiceOrdersToRivhit(invoiceOrdersArray, amounts, createdDates, agentIDs));
    handleCloseModal();
    handleSubmit();
  };

  useEffect(() => {
    setValid(false);
    if (invoiceOrdersList) {
      const isValid = validateInvoiceOrders(invoiceOrdersArray, invoiceOrdersList);
      setValid(isValid);
    }
  }, [invoiceOrdersArray, invoiceOrdersList]);

  const validateInvoiceOrders = (selectedIDs, invoiceOrders) => {
    return invoiceOrders
      .filter(invoiceOrder => selectedIDs.includes(invoiceOrder._id))
      .every(invoiceOrder => Validation.canSendInvoiceOrderToRivhit(invoiceOrder.createdAt));
  };

  return (
    <div className={'invoice-orders-send-all-container'}>
      <Button
        className="btn d-flex align-items-center justify-content-center custom-send-button h-20px w-40px"
        onClick={() => handleShowModal()}
        disabled={can('full', 'invoiceOrders') && !dirty}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Send_white.svg')}
          alt="send" className="h-15px"
        />
      </Button>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">
            <FormattedMessage
              id="invoice-orders-popup-send-to-rivhit"
              defaultMessage="Send to profitable for creation?"
            />
          </h3>
          <div className="d-flex justify-content-center">
            <Button
              className="btn-secondary btn-sm col-3 mx-3 "
              onClick={handleCloseModal}
            >
              <FormattedMessage id="invoice-orders-popup-button-cancel" defaultMessage="Cancel"/>
            </Button>
            <Button
              className="btn-sm col-3 mx-3 custom-send-button"
              onClick={sendInvoiceFunc(invoiceOrdersArray)}
              type="submit"
              disabled={!valid}
            >
              <FormattedMessage id="invoice-orders-popup-button-yes" defaultMessage="Yes"/>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

PopupSendToCreation.propTypes = {};

export default PopupSendToCreation;
